import AdminAiScanReview from "../components/ai-scans/AdminAiScanReview";
import { useAdminAiScanReports } from "../hooks/useAdminAiScanReports";

// Reads the security scan separately so its request and refresh follow this page's lifetime.
// Keeps the unsafe scenario, missing control and remediation together when reviewing each finding.
// The review preserves feature coverage and shared finding references from the source reports.
const AdminAiSecurityScanPage = () => {
  const { reports, featureReports, issues, loading, error, refresh, available } = useAdminAiScanReports("security");

  return (
    <AdminAiScanReview
      scan="security"
      title="Security"
      description="Review security findings by module, business object, surface and feature. Follow each unsafe scenario through the missing control, affected boundary and proposed remediation. Feature coverage distinguishes reviewed areas from those still awaiting a scan."
      featureReviewKey="featureSecurity"
      findingFields={[
        "unsafeScenario",
        "explanation",
        "missingControl",
        "resourceBoundary",
        "routeOrMethod",
        "downstreamCommand",
        "remediation",
        "affectedFeatureIds",
        "canonicalKey",
      ]}
      reports={reports}
      featureReports={featureReports}
      issues={issues}
      loading={loading}
      error={error}
      available={available}
      onRefresh={refresh}
    />
  );
};

export default AdminAiSecurityScanPage;
